import { render, staticRenderFns } from "./AccountBusiness.vue?vue&type=template&id=62a66c5a&scoped=true"
import script from "./AccountBusiness.vue?vue&type=script&lang=js"
export * from "./AccountBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a66c5a",
  null
  
)

export default component.exports